import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Alert, Button, Input, Label, Row, Col, Container, Nav, NavLink, TabContent, TabPane, FormGroup } from 'reactstrap';
import moment from 'moment';
import fileDownload from 'js-file-download';
import 'react-quill/dist/quill.snow.css';
import '../styles/user.css'
import { withRouter } from 'react-router-dom';
import { getTraining } from '../actions/Trainings';
import { b64toBlob, getOptionsFromListofMaps } from '../utils';
import { apiGet } from '../utils/Api';
import { toggleContactNameValidState } from '../actions/Contacts';
import * as actions from '../actions/Person';
import * as userActions from '../actions/User';
import * as staticDataActions from '../actions/StaticData';
import classnames from 'classnames';
import PersonForm from '../components/person';
import Documents from '../components/documents/Documents';
import Journal from '../components/common/Journal';
import Attributes from '../components/person/Attributes';
import ContactInfo from '../components/person/ContactInfo';
import PasswordChangeModal from '../components/person/PasswordChangeModal';
import PersonTrainings from '../components/person/PersonTrainings';
import Breadcrumb from '../components/AdminBreadcrumb';

class Person extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'Demographics',
            showEndDateBeforeStartDate: false,
            maxRateExceeded: false
        }
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.activeTab === "Notes") {
            this.props.actions.getPersonJournal(this.props.location.personId.id);
            this.setState({ activeTab: this.props.location.state.activeTab })
        }
    }

    componentWillUnmount() {
        this.props.actions.clearPerson();
    }

    setRateExcceded = (value) => {
        this.setState({ maxRateExceeded: value })
    }

    handleSave = () => {
        this.setState({ showEndDateBeforeStartDate: false });

        const startDate = this.props.person.activeStartDate;
        const endDate = this.props.person.activeEndDate;

        const activeStartDate = startDate ? moment(startDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.startDate).format(moment.HTML5_FMT.DATE)

        const activeEndDate = endDate ? moment(endDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.endDate).format(moment.HTML5_FMT.DATE)

        if (activeEndDate < activeStartDate) {
            this.setState({ showEndDateBeforeStartDate: true });
        }
        else {
            this.props.actions.savePerson(this.props.person);
            if (this.props.userId)
                this.props.actions.saveUser(this.props.user);
        }
    }

    handleToggleTab = (tab) => {
        if (tab === 'Documents') {
            this.props.actions.getPersonDocuments(this.props.person.personId);
            this.props.actions.getPersonDocumentTypes();
        }

        if (tab === 'Notes') {
            this.props.actions.getPersonJournal(this.props.person.personId);
        }

        if (tab === 'ContactInfo') {
            this.props.actions.getPersonPhones(this.props.person.personId);
            this.props.actions.getPersonAddresses(this.props.person.personId);
            this.props.actions.getPersonEmails(this.props.person.personId);
        }

        this.setState({ activeTab: tab });
    }

    handleAddFiles = (type, files) => this.props.actions.addPersonDocument(this.props.person.personId, type, files);

    handleDocumentTypeChange = (type) => this.props.actions.getPersonDocumentsByType(this.props.person.personId, type);

    handleDeleteDocuments = (personDocumentIds) => {
        this.props.actions.deletePersonDocuments(this.props.person.personId, personDocumentIds);
    }

    handleSavePersonJournalEntry = (journalEntry) => {
        const personId = this.props.person.personId;

        const personJournalEntry =
            journalEntry.id ?
                {
                    personId,
                    personJournalEntryId: journalEntry.id,
                    isActive: true,
                    ...journalEntry
                }
                :
                {
                    personId,
                    isActive: true,
                    ...journalEntry
                };

        return this.props.actions.savePersonJournalEntry(personId, personJournalEntry);
    }

    handleGetPersonJournalEntry = (personJournalEntryId) =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/person/journal/${personJournalEntryId}`)
            .then(res => ({ ...res, id: res.personJournalEntryId }));

    handleDeletePersonJournalEntries = (ids) => this.props.actions.deletePersonJournalEntries(this.props.person.personId, ids);

    handlePersonChange = (person) => {
        this.props.actions.updatePerson(person);
    }

    handleRoleOnChange = (e) => this.props.actions.updateUserRole(e.target.value);

    handleUserActiveChange = (e) => this.props.actions.setUserActiveStatus(e.target.checked);

    handleTogglePasswordChangeModal = () => {
        this.props.actions.togglePasswordChangeModal()
    }            ;

    handleGetRowNodeId = (data) => data.grantId;

    handleFirstDataRendered = (params) => params.api.sizeColumnsToFit();

    handlePasswordSave = (password) => this.props.actions.updateUserPassword(this.props.userId, password);

    onDismissShowEndDateBeforeStartDate = () => {
        this.setState({ showEndDateBeforeStartDate: !this.state.showEndDateBeforeStartDate });
    }

    handleDocumentSave = (personDocumentId, documentTypeId) => this.props.actions.updatePersonDocument(this.props.personId, personDocumentId, documentTypeId);

    render() {
        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Alert color="warning" isOpen={this.state.showEndDateBeforeStartDate} fade={true} toggle={this.onDismissShowEndDateBeforeStartDate}>
                    Active end date cannot occur before training start date
                </Alert>
                <Nav tabs>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === 'Demographics' })}
                        onClick={() => { this.handleToggleTab('Demographics'); }}
                    >
                        Demographics
                    </NavLink>
                    <NavLink
                        disabled={this.props.person.personId === undefined}
                        className={classnames({ active: this.state.activeTab === 'ContactInfo' })}
                        onClick={() => { this.handleToggleTab('ContactInfo'); }}
                    >
                        Contact Info
                    </NavLink>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === 'Attributes' })}
                        onClick={() => { this.handleToggleTab('Attributes'); }}
                    >
                        Attributes
                    </NavLink>
                    <NavLink
                        disabled={this.props.person.personId === undefined}
                        className={classnames({ active: this.state.activeTab === 'Documents' })}
                        onClick={() => { this.handleToggleTab('Documents'); }}
                    >
                        Documents
                    </NavLink>
                    <NavLink
                        disabled={this.props.person.personId === undefined}
                        className={classnames({ active: this.state.activeTab === 'Notes' })}
                        onClick={() => { this.handleToggleTab('Notes'); }}
                    >
                        Notes
                    </NavLink>
                    {this.props.userId &&
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'Security' })}
                            onClick={() => { this.handleToggleTab('Security'); }}
                        >
                            Security
                        </NavLink>
                    }
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane className='pt-1' tabId="Demographics">
                        <PersonForm
                            {...this.props}
                            toggleContactNameValidState={this.props.actions.toggleContactNameValidState}
                            onChange={this.handlePersonChange}

                        />
                    </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane className='pt-1' tabId="ContactInfo">
                        {this.state.activeTab === 'ContactInfo' &&
                            <ContactInfo
                                setField={this.props.actions.setField}
                                addresses={this.props.addresses}
                                addressTypes={this.props.addressTypes}
                                emails={this.props.emails}
                                person={this.props.person}
                                phones={this.props.phones}
                                phoneTypes={this.props.phoneTypes}
                                onChange={this.handlePersonChange}
                                onDeletePersonEmails={this.props.actions.deletePersonEmails}
                                onSavePersonEmail={this.props.actions.savePersonEmail}
                                onDeletePersonPhone={this.props.actions.deletePersonPhones}
                                onSavePersonPhone={this.props.actions.savePersonPhone}
                                onDeletePersonAddresses={this.props.actions.deletePersonAddresses}
                                onSavePersonAddress={this.props.actions.savePersonAddress}
                                states={this.props.states}
                            />}
                    </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="Attributes">
                        <Attributes
                            setMaxRateExceeded={this.setRateExcceded}
                            person={this.props.person}
                            onChange={this.handlePersonChange}
                            courtTypes={this.props.courtTypes}
                            disciplines={this.props.disciplines}
                            personTypes={this.props.personTypes}
                            committeeAssignments={this.props.committeeAssignments}
                            actions={this.props.actions}
                            isValid={!this.state.maxRateExceeded}
                        />
                    </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="Documents">
                        {this.state.activeTab === 'Documents' &&
                            <Documents
                                onSave={this.handleDocumentSave}
                                documentTypes={this.props.personDocumentTypes}
                                onAddFiles={this.handleAddFiles}
                                onTypeChange={this.handleDocumentTypeChange}
                                onDownload={this.handleDocumentDownload}
                                onDelete={this.handleDeleteDocuments}
                                data={this.props.documents}
                                getEntityId={(x) => x.personDocumentId}                
                            />
                        }
                    </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="Notes">
                        {this.state.activeTab === 'Notes' &&
                            <Journal
                                data={this.props.journal}
                                onGet={this.handleGetPersonJournalEntry}
                                onSave={this.handleSavePersonJournalEntry}
                                onDelete={this.handleDeletePersonJournalEntries}
                            />
                        }
                    </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="Security">
                        <Row>
                            <Col>
                                <Label>Role:</Label>
                                <Input type='select' disabled={!this.props.isAdmin} value={this.props.roleId} onChange={this.handleRoleOnChange}>
                                    {getOptionsFromListofMaps(this.props.roles, 'id', 'name', false)}
                                </Input>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='d-flex align-items-center'>
                                <FormGroup check className='pt-3'>
                                    <Label check>
                                        <Input type="checkbox" id="isActive" disabled={!this.props.isAdmin} onChange={this.handleUserActiveChange} checked={this.props.user.isActive} />{' '}
                                        Is Active
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: '1em', flex: 'unset' }}>
                            <Col>
                                <Button onClick={this.handleTogglePasswordChangeModal}>Change Password</Button>
                                <PasswordChangeModal
                                    onSave={this.handlePasswordSave}
                                    fromSecurityTab={true}
                                    showModal={this.props.showPasswordChangeModal}
                                    onToggle={this.handleTogglePasswordChangeModal}
                                    validationMessages={this.props.passwordValidationMessages}
                                />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
                <Row>
                    <Col>
                        <hr />
                        <Button type="submit" className={'float-right'} disabled={!this.props.person.firstName || !this.props.person.lastName || this.state.maxRateExceeded === true} onClick={this.handleSave}>Save</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        personId: state.PersonData.getIn(['person', 'personId']),
        addresses: state.PersonData.get('addresses').toJS(),
        documents: state.PersonData.get('documents').toJS(),
        emails: state.PersonData.get('emails').toJS(),
        journal: state.PersonData.get('journal').toJS(),
        person: state.PersonData.get('person').toJS(),
        phones: state.PersonData.get('phones').toJS(),
        userId: state.PersonData.getIn(['user', 'id']),
        userClaims: state.PersonData.getIn(['user', 'claims']).toJS(),
        roleId: state.PersonData.getIn(['user', 'userRoles', 0, 'roleId']),
        user: state.PersonData.get('user').toJS(),
        showPasswordChangeModal: state.PersonData.get('showPasswordChangeModal'),
        passwordValidationMessages: state.PersonData.get('passwordValidationMessages').toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, ...staticDataActions, ...userActions, toggleContactNameValidState, getTraining }, dispatch) }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Person));